/* eslint-disable import/first */
import React from 'react';
import Button from '@material-ui/core/Button';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import ClassNames from 'classnames';

import {
  Avatar,
  List,
  Radio,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from '@reach/router';
import Cookies from 'js-cookie';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import uaeIcon from '../SideMenu/images/uae.png';
import bhrIcon from '../SideMenu/images/bahrain.png';
import egpIcon from '../SideMenu/images/egypt.png';
import kuwaitIcon from '../SideMenu/images/kuwait.png';
import omIcon from '../SideMenu/images/oman.png';
import jordanIcon from '../SideMenu/images/jordan.png';
import ksaIcon from '../SideMenu/images/ksa.jpg';
import qtrIcon from '../SideMenu/images/qatar.png';
import iconOfCountry from './icon.png';
import {
  capitalizeFirstLetter,
  allowedCountry,
  getCountryURL,
} from 'spwa-ui-library/esm/utils/helper';
import css from './index.module.scss';
import Loader from '../Loader';

const { getHomeJsonComponents, getClusterId } = Slices.configSlice;
const { countrySwitch } = Slices.countrySlice;
const { switchCountryUser } = Slices.authSlice;
const { fetchMenu, clearMenu } = Slices.menuSlice;
const { clearProduct } = Slices.productSlice;
const { clearCategory } = Slices.categorySlice;
const { handleCountryPopup, handleAddressNavigation } = Slices.appSlice;
const { clearHome, fetchHome } = Slices.homeSlice;
const { getProfile, selectCurrentCountry } = Slices.profileSlice;
const { clearCart, cartItems } = Slices.cartSlice;
const { clearStoreList } = Slices.storeSlice;
const { clearCityList } = Slices.citySlice;
const { clearAddress, fetchAddress } = Slices.addressSlice;
const { clearState } = Slices.orderSlice;
const { clearFavo } = Slices.favouriteSlice;
const { clearCustomizeItems } = Slices.tempCartSlice;

// eslint-disable-next-line import/no-mutable-exports
export let dataList = [
  {
    name_en: 'United Arab Emirates',
    name_ar: 'الإمارات العربية المتحدة',
    code: 'UAE',
    flag: uaeIcon,
    number_code: '(+971)',
  },
  {
    name_en: 'Saudi Arabia',
    code: 'KSA',
    name_ar: 'السعودية',
    flag: ksaIcon,
    number_code: '(+966)',
  },
  // { name_en: 'Bahrain', code: 'BHR', name_ar: 'البحرين', flag: bhrIcon, number_code: '(+973)' },
  // { name_en: 'Egypt', code: 'EGY', name_ar: 'مصر', flag: egpIcon, number_code: '(+20)' },

  // {
  //   name_en: 'Egypt',
  //   code: 'EGY',
  //   name_ar: 'Ù…ØµØ±',
  //   flag: egpIcon,
  //   number_code: '(+20)',
  // },
  // {
  //   name_en: 'Kuwait',
  //   code: 'KWT',
  //   name_ar: 'Ø§Ù„ÙƒÙˆÙŠØª',
  //   flag: kuwaitIcon,
  //   number_code: '(+965)',
  // },
  // {
  //   name_en: 'Oman',
  //   code: 'OMN',
  //   name_ar: 'Ø³Ù„Ø·Ù†Ø© Ø¹Ù…Ø§Ù†',
  //   flag: omIcon,
  //   number_code: '(+968)',
  // },
  // {
  //   name_en: 'Jordan',
  //   code: 'JOR',
  //   name_ar: 'Ø§Ù„Ø£Ø±Ø¯Ù†',
  //   flag: jordanIcon,
  //   number_code: '(+962)',
  // },
  // // { name_en: 'Oman', code: 'OMN', flag: omIcon, number_code: '(+968)', },
  // { name_en: 'Qatar', code: 'QAT', name_ar: 'Ù‚Ø·Ø±', flag: qtrIcon, number_code: '(+974)' },
];
const SwipeableCountryDrawer = () => {
  const currentCountry = useSelector(selectCurrentCountry);
  const intl = useIntl();
  const location = useLocation();
  const [switchCountry, setSwitchCountry] = React.useState(currentCountry);
  const config = useSelector((state) => state.config);
  const profile = useSelector((state) => state.profile);
  const allProfiles = profile?.data?.data;
  const blobURL = useSelector(getHomeJsonComponents);
  const [pageLoad, setPageLoad] = React.useState(false);
  const cartItemList = useSelector(cartItems);
  const [currentPhone, setCurrentPhone] = React.useState('');
  const [countrySelected, setCountrySelected] = React.useState(switchCountry);
  const clusterId = useSelector(getClusterId);
  const dispatch = useDispatch();

  const theme = createMuiTheme({
    palette: {
      primary: { main: '#EE3A43' },
      secondary: { main: '#393f5233' },
    },
  });

  dataList = dataList.sort(function (a, b) {
    const nA = a[`name_${intl.locale}`]?.toLowerCase();
    const nB = b[`name_${intl.locale}`]?.toLowerCase();
    if (nA < nB) return -1;
    else if (nA > nB) return 1;
    return 0;
  });
  const isGridView = dataList.length > 3;
  const toggleCountry = (code) => {
    setCountrySelected(code);
  };
  const changeCountry = () => {
    if (switchCountry !== countrySelected) {
      setPageLoad(true);
      const payloadCountry = {
        country: countrySelected,
      };
      const isExist = config.data.data.contrySpecificValidation.findIndex(
        ({ country }) => country === countrySelected
      );
      Cookies.set('country', countrySelected, { expires: 365 });
      const payloadMenu = {
        blob: blobURL,
        country: countrySelected.toUpperCase(),
        brand: 'kfc',
        lang: capitalizeFirstLetter(intl.locale),
        defMenu: config.data.data.contrySpecificValidation[isExist].defaultMenuId,
        menu: config.data.data.contrySpecificValidation[isExist].defaultMenuTempId,
        cluster: clusterId,
      };
      const homePayload = {
        blob: blobURL,
        lang: capitalizeFirstLetter(intl.locale),
        country: countrySelected.toLowerCase(),
        id: config.data.data.contrySpecificValidation[isExist].defaultMenuId,
        template: config.data.data.contrySpecificValidation[isExist].defaultMenuTempId,
        cluster: clusterId,
      };

      Promise.allSettled([
        dispatch(clearCart()),
        dispatch(clearCustomizeItems()),
        dispatch(clearMenu()),
        dispatch(clearProduct()),
        dispatch(clearCategory()),
        dispatch(clearHome()),
        dispatch(clearFavo()),
        dispatch(clearState()),
        dispatch(clearAddress()),
      ]);
      dispatch(countrySwitch(payloadCountry))
        .then(async (resp) => {
          window.localStorage.removeItem('_PMI');
          window.localStorage.removeItem('_MPS');
          setPageLoad(false);
          dispatch(handleCountryPopup());
          const updatedProfile = resp.payload.data;

          Promise.allSettled([
            dispatch(switchCountryUser(updatedProfile)),
            dispatch(fetchMenu(payloadMenu)),
            dispatch(fetchHome(homePayload)),
          ]);
          dispatch(getProfile()).then((resp) => {
            Promise.allSettled([
              dispatch(clearStoreList()),
              dispatch(clearCityList()),
              dispatch(fetchAddress()),
            ]).then(() => {
              window.location.reload();
            });
          });
        })
        .catch((e) => {
          setPageLoad(false);
        });
    } else {
      Promise.allSettled([dispatch(handleCountryPopup()), dispatch(handleAddressNavigation())]);
    }
  };

  const redirectCountry = () => {
    if (switchCountry !== countrySelected) {
      if (location.hostname !== 'localhost') {
        const countryURL = getCountryURL(countrySelected, process.env.REACT_APP_ENV);
        window.location.replace(`https://${countryURL}`);
      } else {
        changeCountry();
      }
    } else {
      Promise.allSettled([dispatch(handleCountryPopup()), dispatch(handleAddressNavigation())]);
    }
  };

  const nameVal = `name_${intl.locale}`;
  React.useEffect(() => {
    const findProfile = allProfiles?.filter((el) => el.country === countrySelected);
    if (findProfile && findProfile?.length > 0) setCurrentPhone(findProfile[0]?.phnNo || '');
  }, [allProfiles, countrySelected]);
  return (
    <>
      <div className={css.root}>
        {pageLoad && <Loader />}
        <div className={css.topPos}>
          <img src={iconOfCountry} alt="login" />
        </div>
        <h3>
          <FormattedMessage id="changeCountry_heading" defaultMessage="Welcome to Pizza Hut" />
        </h3>
        <p>
          <FormattedMessage
            id="countryDrop_Heading"
            defaultMessage="Please select the country where you want to order"
          />
          <span role="img" aria-label="img tag">
            🍕
          </span>
        </p>
        <div className={css.displayPhoneNumber}>
          <FormattedMessage
            id="youNeedToHaveLocalMobileNumber"
            defaultMessage="You need to have a local mobile number"
          />
        </div>
        {/* )} */}
        {/* <h5>Your number for ordering is 585001678</h5> */}
        <div className={css.countryCheckBox}>
          <List disablePadding className={isGridView ? css.gridView : ''}>
            {dataList
              .sort((a, b) => Number(switchCountry === b.code) - Number(switchCountry === a.code))
              .map((dataItem, idx) => {
                if (dataList.country !== dataItem.code && allowedCountry(dataItem.code)) {
                  return (
                    <ListItem
                      button
                      component="label"
                      htmlFor={idx}
                      ContainerProps={{
                        className: ClassNames(css.listItem, {
                          [css.activeListItem]: countrySelected === dataItem.code,
                        }),
                      }}
                    >
                      <Avatar
                        variant="square"
                        alt={dataItem.name}
                        src={dataItem.flag}
                        className={css.image}
                      />
                      <ListItemText
                        primary={dataItem[nameVal] + ' ' + dataItem.number_code}
                        className={css.title}
                      />
                      <ListItemSecondaryAction className={css.checkbox}>
                        <ThemeProvider theme={theme}>
                          <Radio
                            className={css.radioButton}
                            checked={countrySelected === dataItem.code ? true : false}
                            color={countrySelected === dataItem.code ? 'primary' : 'secondary'}
                            id={idx}
                            edge="end"
                            onChange={() => toggleCountry(dataItem.code)}
                          />
                        </ThemeProvider>
                      </ListItemSecondaryAction>
                    </ListItem>
                  );
                } else {
                  return '';
                }
              })}
          </List>
        </div>
        {/* {countOfItems > 0 && (
          <div className={css.cartItemCondition}>
            <img src={subtractIcon} alt="" className={css.subtractIconCss} />
            <FormattedMessage
              id="onChangingCountryYourCartWillBeDropped"
              defaultMessage="On changing the country, your cart will be dropped"
            />
          </div>
        )} */}
      </div>
      <div className={css.actionContainer}>
        <Button
          variant="contained"
          // disabled={switchCountry === countrySelected}
          color="primary"
          className={css.actionButton}
          onClick={() => redirectCountry()}
        >
          <FormattedMessage id="changeCountry_proceed" defaultMessage="Change Country" />
        </Button>
      </div>
    </>
  );
};

export default SwipeableCountryDrawer;
